var map = {
	"./gem_efficiency_lv1.jpg": 8489,
	"./gem_efficiency_lv2.jpg": 752,
	"./gem_efficiency_lv3.jpg": 210,
	"./gem_efficiency_lv4.jpg": 8325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9288;